import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsHinhThucDaoTao } from '../../services/danhmuc';

const HinhThucDaoTaoSelectBox = ({ value, disabled, onChange }: { value?: number, disabled?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsHinhThucDaoTao(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn hình thức đào tạo--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default HinhThucDaoTaoSelectBox;
